import posed from 'react-pose'

export const FadeIn = posed.div({
  enter: {
    opacity: 1,
    delayChildren: 200,
    staggerChildren: 50
  },
  exit: { opacity: 0 }
})

export const SlideUp = posed.div({
  enter: { y: 0, opacity: 1 },
  exit: { y: 50, opacity: 0 }
})

export const SlideLeft = posed.div({
  enter: { x: 0, opacity: 1 },
  exit: { x: 50, opacity: 0 }
})



// WEBPACK FOOTER //
// ./src/components/animation/index.js